import { useStoreAuth } from "../store";

export default function useAPIKeys() {
  const { client } = useStoreAuth();

  const createAPIKey = async ({ name, expiresIn, prefix, configId, organizationId, metadata } = {}) => {
    const { data, error } = await client.apiKey.create({
      name,
      expiresIn,
      prefix,
      configId,
      organizationId,
      metadata,
    });
    if (error) {
      console.error("Error creating API key:", error);
      return { error };
    }
    return { data };
  };

  const verifyAPIKey = async ({ key, permissions } = {}) => {
    const { data, error } = await client.apiKey.verify({
      body: {
        key,
        permissions,
      },
    });
    if (error) {
      console.error("Error verifying API key:", error);
      return { error };
    }
    return { data };
  };

  const getAPIKey = async (id) => {
    const { data, error } = await client.apiKey.get({
      query: {
        id,
      },
    });
    if (error) {
      console.error("Error getting API key:", error);
      return { error };
    }
    return { data };
  };

  const updateAPIKey = async ({ keyId, name, configId } = {}) => {
    const { data, error } = await client.apiKey.update({
      keyId,
      name,
      configId,
    });
    if (error) {
      console.error("Error updating API key:", error);
      return { error };
    }
    return { data };
  };

  const deleteAPIKey = async (keyId, { configId } = {}) => {
    const { data, error } = await client.apiKey.delete({
      keyId,
      configId,
    });
    if (error) {
      console.error("Error deleting API key:", error);
      return { error };
    }
    return { data };
  };

  const listAPIKeys = async ({ organizationId } = {}) => {
    const { data, error } = await client.apiKey.list({
      query: organizationId ? { organizationId } : undefined,
    });
    if (error) {
      console.error("Error listing API keys:", error);
      return { error };
    }
    return { data };
  };

  return {
    createAPIKey,
    verifyAPIKey,
    getAPIKey,
    updateAPIKey,
    deleteAPIKey,
    listAPIKeys,
  };
}
